// @flow
import React from 'react';
import { Container, Row, Col } from 'Components/Grid';
import DefaultPage from 'Containers/DefaultPage';
import HeroHeader from 'Components/HeroHeader';
import RichText from 'Components/RichText';
import Gallery from 'Components/Gallery';
import IntroText from 'Components/IntroText';
import AboutUsModel from 'Stores/AboutUsModel';
import { getGivenBackground } from 'Utils/getColor/index';

type Props = {
  data: {},
  deeplinkId?: number,
};

type State = {
  aboutus: AboutUsModel,
};

export default class AboutUs extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      aboutus: props.data instanceof AboutUsModel ? props.data : new AboutUsModel(props.data),
    };
  }

  UNSAFE_componentWillReceiveProps(props: Props) {
    this.setState({ aboutus: new AboutUsModel(props.data) });
  }

  render() {
    const { aboutus } = this.state;

    return (
      <DefaultPage background={getGivenBackground('white')} deeplinkId={this.props.deeplinkId}>
        <HeroHeader image={aboutus.image} />
        <IntroText title={aboutus.title} text={aboutus.intro} headerLayout="h1" />
        <Container>
          <Row align="center">
            <Col cols={12} l={8}>
              <RichText content={aboutus.text} />
            </Col>
          </Row>
        </Container>
        {!aboutus.gallery.empty() && <Gallery images={aboutus.gallery.items} />}
      </DefaultPage>
    );
  }
}
